import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from 'src/components'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import { CustomButton } from '../CustomButton/CustomButton'
import Toast from '../Toast/Toast'
import TransactionInput from '../TransactionInput/TransactionInput'
import styles from './TransactionContainer.module.scss'

interface Props {
  typeOfHeader: 'action' | 'back'
  title: string
  subtitle: string
  buttonText: string
  onTransferStars: (value: string) => void

  minValueForTransaction: number
  className?: string

  typeOfTransaction?: 'withdraw' | 'send'
}

const TransactionContainer: React.FC<Props> = ({
  typeOfHeader,
  title,
  subtitle,
  buttonText,
  className,
  onTransferStars,
  minValueForTransaction,
  typeOfTransaction = 'send',
}) => {
  const { t } = useTranslation()

  const [inputValue, setInputValue] = useState<string>('')
  const [notEnoughStars, setNotEnoughStars] = useState<boolean>(false)

  const balanceStars = useGlobalStore((state) => state.user?.balance_stars)

  const handleChangeInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value)
    setInputValue(String(value))

    if (value > (balanceStars || 0) || value < minValueForTransaction) {
      setNotEnoughStars(true)
    } else {
      setNotEnoughStars(false)
    }
  }

  return (
    <div className={className}>
      <Header variant={typeOfHeader} action='add' path='..' />

      <Toast isVisible={notEnoughStars} />

      {typeOfTransaction === 'withdraw' && <Toast isVisible={true} type='withdraw' />}

      <main className={styles.wrapper}>
        <h1>{title}</h1>
        <p className={styles.wrapper_subtitle}>{subtitle}</p>

        <TransactionInput
          commission={t('transaction_input.not_commission')}
          inputValue={inputValue}
          handleChange={handleChangeInputValue}
        />
      </main>

      <CustomButton
        onClick={() => onTransferStars(inputValue)}
        variant={
          inputValue.length === 0 || notEnoughStars || +inputValue < minValueForTransaction || inputValue === '0'
            ? 'not-active'
            : 'contained'
        }
        color='white'
        className={styles.button}
      >
        {buttonText}
      </CustomButton>
    </div>
  )
}

export default TransactionContainer
